<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Header from './components/Header.vue'
// import Aside from "./components/Aside.vue"
import watermark from "./utils/waterMark";
export default {
  name: "App",
  components: {
    // Header,
    // Aside
  },
  created: function () {
    const { username } = JSON.parse(localStorage.getItem("userInfo") || "{}");
    if (username) {
      watermark.set(username, document.documentElement);
    }
    if (localStorage.getItem("userInfo")) {
      this.$store.commit(
        "setLoaclUserInfo",
        JSON.parse(localStorage.getItem("userInfo") || "{}")
      );
    }
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100%;
  background: rgba(249, 251, 255, 1);
  /* min-height: 900px; */
  /* min-width: 1400px; */
}
</style>
